<template>
  <require from="./af-highlight.html"></require>

  <li repeat.for="item of items" class="${selectedIndex === $index ? '--selected' : ''}" click.delegate="selectItem(item)" as-element="af-highlight" text.bind="getValue(item)" highlight.bind="boundText"></li>
</template>
